module.exports = __webpack_public_path__ + "img/大载重机场2.4f85c885.png";